import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/pageService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML, convertFromHTML } from "draft-convert";

class PageForm extends Form {
  state = {
    preferredDate: new Date(),
    imageUrl: "",
    data: {
      title: "",
      slug: "",
    },
    editorState: EditorState.createEmpty(),
    errors: {},
  };

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  schema = {
    id: Joi.string(),
    title: Joi.string().required().label("Title"),
    slug: Joi.string().required().label("Slug"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      const text = convertToHTML(this.state.editorState.getCurrentContent());

      let formData = new FormData();
      formData.append("title", this.state.data.title);
      formData.append("slug", this.state.data.slug);
      formData.append("description", text);
      formData.append("image", this.state.imageUrl);

      await saveSingle(formData);

      toast.success("Page has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/web/pages");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.address)
          errors.address = ex.response.data.errors.address;

        if (ex.response.data.errors.phone)
          errors.phone = ex.response.data.errors.phone;

        if (ex.response.data.errors.account)
          errors.account = ex.response.data.errors.account;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  onChangeImage = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    const { editorState } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle
          title="Add Page"
          icon="tag"
          color="white"
          iconPath={dashboardIcon}
        />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "70%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">Add Page</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("title", "Title", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("slug", "Slug", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <Editor
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      wrapperStyle={{ height: "auto" }}
                      editorStyle={{
                        height: "400px",
                        border: "1px solid #eeeeee",
                        padding: "7px",
                        paddingTop: "0px",
                      }}
                      toolbarStyle={{}}
                      editorState={editorState}
                      onEditorStateChange={this.onEditorStateChange}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    <label>Image</label>
                    <input
                      className="input_imagem_artigo"
                      type="file"
                      onChange={this.onChangeImage}
                    />
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Save")}
                    <Link to="/web/pages" className="ui secondary button">
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default PageForm;
